export const securitySetup = {
  junior: {
    requirements: [
      { name: 'Design Asset Security Training', description: 'Complete training on secure handling of design assets and intellectual property', priority: 'high' },
      { name: 'Client Data Protection', description: 'Learn secure practices for handling client and user data in designs', priority: 'high' },
      { name: 'Design Tool Security', description: 'Secure configuration of design tools and cloud storage', priority: 'medium' },
      { name: 'Brand Asset Protection', description: 'Understand brand asset security and usage guidelines', priority: 'medium' }
    ],
    procedures: [
      { step: 'Complete design security training', command: 'Complete company design asset security and IP protection training' },
      { step: 'Set up secure design storage', command: 'Configure secure cloud storage for design files with proper access controls' },
      { step: 'Enable 2FA on design tools', command: 'Enable two-factor authentication on all design platforms' },
      { step: 'Review asset sharing procedures', command: 'Understand secure design asset sharing and collaboration procedures' }
    ]
  },
  mid: {
    requirements: [
      { name: 'Advanced Design Security', description: 'Implement advanced security measures for design workflows', priority: 'high' },
      { name: 'Cross-platform Security', description: 'Ensure security across multiple design platforms and tools', priority: 'high' },
      { name: 'Design Audit Compliance', description: 'Conduct regular security audits of design processes', priority: 'medium' },
      { name: 'Vendor Security Assessment', description: 'Assess security of design tools and third-party platforms', priority: 'medium' }
    ],
    procedures: [
      { step: 'Implement design governance', command: 'Set up design governance framework with security controls' },
      { step: 'Conduct security assessments', command: 'Regular security assessment of design tools and workflows' },
      { step: 'Set up access monitoring', command: 'Implement monitoring for design asset access and sharing' },
      { step: 'Create incident response plan', command: 'Develop incident response procedures for design security issues' }
    ]
  },
  senior: {
    requirements: [
      { name: 'Design Security Strategy', description: 'Define comprehensive security strategy for design operations', priority: 'high' },
      { name: 'Enterprise Design Governance', description: 'Establish enterprise-wide design governance and compliance', priority: 'high' },
      { name: 'IP Protection Framework', description: 'Implement intellectual property protection for design assets', priority: 'high' },
      { name: 'Security Culture Development', description: 'Foster security-conscious culture within design teams', priority: 'medium' }
    ],
    procedures: [
      { step: 'Develop security framework', command: 'Create comprehensive security framework for design operations' },
      { step: 'Implement governance controls', command: 'Design and implement enterprise design governance controls' },
      { step: 'Establish compliance monitoring', command: 'Set up continuous compliance monitoring for design processes' },
      { step: 'Security awareness program', command: 'Develop security awareness and training program for design teams' }
    ]
  }
};
